<template>
    <div class="container" itemscope itemtype="https://schema.org/Review" @touchstart="handleTouchStart"
         @touchend="handleTouchEnd">

        <div class="arrow-container left" @click="previousReview">
            <div class="arrow-left"></div>
        </div>

        <div class="full-reviews" v-if="currentReviews.length" ref="reviewsContainer">

            <div v-for="review in currentReviews" :key="review.id" class="full-review" itemscope itemtype="https://schema.org/Review">
                <meta itemprop="name" :content="appName" />

                <div itemprop="author" itemscope itemtype="https://schema.org/Person">
                    <span class="d-none" itemprop="name">{{ review.name }}</span>
                </div>

                <section itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating">

                    <div class="arrow-container left-mobile" @click="previousReview">
                        <div class="arrow-left-mobile"></div>
                    </div>

                    <div class="star-rating">
                        <div class="stars">

                    <span :content="review.stars"
                          itemprop="ratingValue">{{ generateStarRating(review.stars) }}</span>
                            <svg width="27" height="21" viewBox="0 0 27 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 21L0.942631 0.75L26.0574 0.75L13.5 21Z" fill="#088673" />
                            </svg>

                            <svg width="42" height="5" viewBox="0 0 42 5" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <ellipse cx="21" cy="2.5" rx="21" ry="2.5" fill="#088673" fill-opacity="0.4" />
                            </svg>
                        </div>
                    </div>

                    <div class="arrow-container right-mobile" @click="nextReview">
                        <div class="arrow-right-mobile"></div>
                    </div>

                    <div class="row justify-content-center">
                        <div class="review-wrapper">

                            <svg class="marks" width="45" height="41" viewBox="0 0 45 41" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.698425" width="43.6032" height="41" rx="11" fill="#088673" />
                                <rect x="10.4603" y="19.8492" width="11.2486" height="11.9328" rx="3" fill="#F0F8F7" />
                                <path
                                    d="M13.3699 9.10701L13.4846 9.2103C17.1351 12.4981 19.8624 16.7802 21.3781 21.604V21.604"
                                    stroke="#F0F8F7" />
                                <path
                                    d="M13.403 9.16328L14.9778 11.6374C16.3705 13.8255 17.4563 16.2138 18.2037 18.733L18.6965 20.3942"
                                    stroke="#F0F8F7" />
                                <path d="M18.4005 14.5847L14.7612 10.7241L19.0622 20.5511H21.0472L18.4005 14.5847Z"
                                      fill="#F0F8F7" />
                                <rect x="23.0323" y="19.6806" width="11.2486" height="11.9328" rx="3" fill="#F0F8F7" />
                                <path
                                    d="M25.9419 8.93845L26.0565 9.04174C29.7071 12.3296 32.4344 16.6117 33.9501 21.4355V21.4355"
                                    stroke="#F0F8F7" />
                                <path
                                    d="M25.975 8.99472L27.5498 11.4688C28.9425 13.6569 30.0283 16.0453 30.7757 18.5645L31.2685 20.2256"
                                    stroke="#F0F8F7" />
                                <path d="M30.9726 14.4162L27.3333 10.5555L31.6342 20.3826H33.6193L30.9726 14.4162Z"
                                      fill="#F0F8F7" />
                            </svg>

                            <div class="review-container">
                                <div class="review-content">
                                    <div class="text-container">
                                        <div class="review-text">
                                            <p itemprop="reviewBody">{{ review.text }}</p>
                                        </div>
                                    </div>

                                    <div class="reviewer">
                                        <div class="reviewer-icon">
                                            <svg width="43" height="51" viewBox="0 0 33 41" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="16.5" cy="16.5" r="9.5" fill="#F0F8F7" />
                                                <path
                                                    d="M1.23098 32.3997C8.24758 19.4385 27.1085 20.2401 33 33.75H0.5L1.23098 32.3997Z"
                                                    fill="#F0F8F7" />
                                                <path
                                                    d="M0 36C0 33.2386 2.23858 31 5 31H28C30.7614 31 33 33.2386 33 36C33 38.7614 30.7614 41 28 41H5C2.23858 41 0 38.7614 0 36Z"
                                                    fill="#F0F8F7" />
                                            </svg>
                                            <svg width="71" height="71" viewBox="0 0 71 71" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="35.5" cy="35.5" r="35.5" fill="#088673" />
                                                <circle cx="63" cy="59" r="7.5" fill="#088673" stroke="#F0F8F7" />
                                                <line x1="59.6" y1="59.2" x2="63.6" y2="62.2" stroke="#F0F8F7"
                                                      stroke-width="2" />
                                                <line x1="62.2318" y1="62.3598" x2="67.2318" y2="56.3598"
                                                      stroke="#F0F8F7"
                                                      stroke-width="2" />
                                            </svg>
                                        </div>
                                        <div class="reviewer-name" itemprop="author" itemscope
                                             itemtype="https://schema.org/Person">
                                            <hr>
                                            <span><span itemprop="name">{{ review.name }}</span>

                                                <span  v-if="review.trustpilot_link !== null">
                                                    <span class="nameFrom" v-html="$t('frontend.customerReviews_from')"></span>
                                                    <a :href="review.trustpilot_link" target="_blank" rel="nofollow"><img class="nameTrustpilot" width="80" :src="trustpilotLogo"></a>
                                                </span>

                                            </span>
                                            <span class="review-date">{{ formatDate(review.created_at) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


        </div>

        <div class="arrow-container right" @click="nextReview">
            <div class="arrow-right"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'customer-reviews',
    props: {
        trustpilotLogo: {
            type: String,
            required: true,
        },
        appName: {
            type: String,
            required: true,
        },
        autoSlideTimer: {
            type: Number,
            default: 30000,
        },
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
        return {
            currentIndex: 0,
            touchStartX: 0,
            touchEndX: 0,
            autoSlideInterval: null,
        };
    },
    computed: {
        currentReviews() {
            if (this.items.length > 0) {
                if (window.innerWidth < 1000) {
                    return [this.items[this.currentIndex % this.items.length]];
                } else {
                    const nextIndex = (this.currentIndex + 1) % this.items.length;
                    return [
                        this.items[this.currentIndex % this.items.length],
                        this.items[nextIndex],
                    ];
                }
            }
            return [];
        },
    },
    mounted() {
        this.setAutoSlide();
    },
    beforeDestroy() {
        clearInterval(this.autoSlideInterval);
    },
    methods: {
        generateStarRating(stars) {
            const fullStars = '★'.repeat(stars);
            const emptyStars = '☆'.repeat(5 - stars);
            return fullStars + emptyStars;
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        },
        updateIndex(step) {
            this.currentIndex = this.currentIndex + step;

            if(this.currentIndex <= -1) {
                this.currentIndex = this.items.length;
            }
        },
        previousReview() {
            setTimeout(() => {
                this.updateIndex(window.innerWidth < 1000 ? -1 : -2);
            }, 399);
            this.slideTransition('left');
        },
        nextReview() {
            setTimeout(() => {
                this.updateIndex(window.innerWidth < 1000 ? 1 : 2);
            }, 399);
            this.slideTransition('right');
        },
        handleTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
        },
        handleTouchEnd(event) {
            this.touchEndX = event.changedTouches[0].clientX;
            this.handleGesture();
        },
        handleGesture() {
            if (this.touchEndX < this.touchStartX) {
                this.nextReview();
            } else if (this.touchEndX > this.touchStartX) {
                this.previousReview();
            }
        },
        setAutoSlide() {
            this.autoSlideInterval = setInterval(() => {
                this.nextReview();
            }, this.autoSlideTimer);
        },
        slideTransition(direction) {
            if (direction === 'left') {
                this.$refs.reviewsContainer.classList.add('slide-left');

                setTimeout(() => {
                    this.$refs.reviewsContainer.classList.remove('slide-left');
                    this.$refs.reviewsContainer.classList.add('slide-normal');
                }, 500);

                setTimeout(() => {
                    this.$refs.reviewsContainer.classList.remove('slide-normal');
                }, 1000);
            }
            if (direction === 'right') {
                this.$refs.reviewsContainer.classList.add('slide-right');

                setTimeout(() => {
                    this.$refs.reviewsContainer.classList.add('slide-left');
                }, 200);

                setTimeout(() => {
                    this.$refs.reviewsContainer.classList.remove('slide-left');
                    this.$refs.reviewsContainer.classList.remove('slide-right');
                    this.$refs.reviewsContainer.classList.add('slide-normal');
                }, 500);

                setTimeout(() => {
                    this.$refs.reviewsContainer.classList.remove('slide-normal');
                }, 1000);
            }
        },
    },
};
</script>

<style scoped>
.review-wrapper {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    align-content: center;
    position: relative;
    width: 420px;
    min-height: 280px;

    border-radius: 24px;
    background: #F0F8F7;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

@media (max-width: 700px) {
    .review-wrapper {
        max-width: 100%;
        margin-left: 10px;
        margin-right: 10px;
    }
}

.review-wrapper .marks {
    margin: 10px;
    padding: 5px;
    position: absolute;
    right: 0;
}

.full-review {
    max-width: 100%;
}

.full-reviews {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 100px;
    transition: transform 0.5s ease, opacity 0.5s ease;
    transform: translateX(0);
    opacity: 1;
    max-width: 100%;
}

.slide-left {
    transform: translateX(-10%);
    opacity: 0;
}

.slide-normal {
    transform: translateX(0);
    opacity: 1;
}

.slide-right {
    transform: translateX(10%);
    opacity: 0;
}

svg {
    position: absolute;
}

.background-svg {
    z-index: -2;
}

.foreground-svg {
    z-index: -1;
}

.review-container {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
}

.star-rating {
    text-align: center;
    font-size: 24px;
    position: relative;

    margin-bottom: 20px;
}

.star-rating .stars {
    border-radius: 9px;
    background: #088673;
    padding: 3px 15px;
    display: inline-block;
    position: relative;
}

.star-rating .stars svg {
    position: absolute;
    left: 80%;
    transform: translateX(-80%);
}

.star-rating .stars svg:first-of-type {
    top: calc(90%);
}

.star-rating .stars svg:nth-of-type(2) {
    left: 83%;
    transform: translateX(-80%);
    top: calc(100% + 10px + 10px);
}

.star-rating .stars span {
    color: white;
}

.review-content {
    padding: 13px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.review-container .text-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: center;
}

.review-content .review-text {
    margin-top: 20px;
    font-size: 16px;
    color: #333333;
    position: relative;
    text-align: left;
}

.reviewer {
    display: flex;
    align-items: center;
    padding: 10px 0;
    margin-top: 50px;
}

.reviewer-info {
    display: flex;
    align-items: center;
}

.reviewer-icon {
    width: 70px;
    height: 70px;
    background-color: #088673;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: #ffffff;
    margin-right: 10px;
}

.reviewer-icon svg:nth-of-type(1) {
    margin-top: -10px;
    position: absolute;
    z-index: 1;
}

.reviewer hr {
    margin-bottom: 10px;
    width: 240px;
    border: 1px solid #088673;
}

.reviewer-name {
    margin-left: 10px;
    font-size: 20px;
    color: #088673;
    text-align: left;
}

.reviewer-name .nameFrom {
    color: #999999;
    font-size: 14px;
}

.reviewer-name .nameTrustpilot {
    background: #088673;
    margin: 0;
    padding: 5px;
    border-radius: 4px;
}

.review-date {
    display: block;
    font-size: 12px;
    color: #999999;
}

.arrow-left {
    transform: rotate(-45deg);
    margin-right: 50px;
}

.arrow-left-mobile {
    transform: rotate(-45deg);
    display: none;
}

.arrow-right {
    transform: rotate(135deg);
    margin-left: 50px;
}

.arrow-right-mobile {
    transform: rotate(135deg);
    display: none;
}

@media (min-width: 1000px) {
    .arrow-right-mobile, .arrow-left-mobile {
        display: none;
    }
}

@media (max-width: 1000px) {
    .arrow-right {
        right: 4%;
        transform: translate(-50%, -4%);
    }

    .arrow-right-mobile {
        display: block;
    }

    .arrow-left {
        left: 7%;
        transform: translate(-50%, -7%);
        z-index: 1000;
    }

    .arrow-left-mobile {
        display: block;
        z-index: 1000;
    }
}

.arrow-right,
.arrow-left, .arrow-left-mobile, .arrow-right-mobile {
    width: 30px;
    height: 30px;
    border-top: 2px solid #088673;
    border-left: 2px solid #088673;
    cursor: pointer;
    z-index: 1000;
}

.arrow-container {
    z-index: 1500;
    position: absolute;
    padding: 30px;
    cursor: pointer;
}

.arrow-container.right-mobile {
    top: -5%;
    right: 2%;
    transform: translate(-5%, -2%);
}

.arrow-container.left-mobile {
    top: -5%;
    left: 2%;
    transform: translate(-5%, -2%);
}

.arrow-container.left {
    top: 50%;
    left: 12%;
    transform: translateY(-50%);
}

.arrow-container.right {
    top: 50%;
    left: 85%;
    transform: translate(-50%, -85%);
}

@media (max-width: 1300px) {
    .arrow-left, .arrow-right {
        display: none;
    }

    .arrow-left-mobile, .arrow-right-mobile {
        display: block;
    }
}

@media (max-width: 1000px) {
    .reviewer-icon {
        width: 30px;
        height: 30px;
    }

    .reviewer-icon svg:nth-of-type(1) {
        width: 30px;
        height: 30px;
    }

    .reviewer-icon svg:nth-of-type(2) {
        width: 50px;
        height: 50px;
    }

    .reviewer-name {
        margin-left: 30px;
    }

    .reviewer hr {
        width: 170px;
    }
}

</style>
